import { Routes } from '@angular/router';
import { ConfiguratorComponent } from './container/configurator.component';

export const CONFIGURATOR_ROUTES: Routes = [
    {
        path: '',
        component: ConfiguratorComponent,
    },
];
